import React, { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { useEffectSkipFirst, useForm } from 'utils/hooks'
import { Button } from 'react-bootstrap'
import { SelectField } from 'components/shared/input'
import { A4 } from 'components/shared/print'
import { selectYears, setPageSize } from 'utils/util'
import { useGroupApi } from 'api/group_by'
import moment from 'moment'
import { SampleSearchForm } from 'entities/sample'
import styled from 'styled-components'
import _ from 'lodash'
import { LedgerFooter, LedgerHeader } from '../ledger_componet'

type Props = {
    history: H.History
}

const Th = styled.th`
    border: solid 1px black;
    padding: 5px;
    text-align: center;
`

const Td = styled.td`
    border: solid 1px black;
    padding: 14px 5px;
    text-align: center;
`

const DisposalLedgerPage = ({ history }: Props) => {
    const globalState = useContext(GlobalStateContext)
    const initDate = { start: moment().startOf('month').format('YYYY-MM-DD'), end: moment().endOf('month').format('YYYY-MM-DD') }
    const periodForm = useForm<{ year: string; month: string }>({
        year: moment().format('YYYY'),
        month: moment().format('MM'),
    })

    const searchForm = useForm<SampleSearchForm>({
        groupBy: 'disposal_history__date',
        aggregate: 'Count("id")',
        aggregateAlias: 'count',
        groupingValues: 'disposal_history__date,disposal_history__note,delivery_date,institution__name,code',
        disposedDateAfter: initDate.start,
        disposedDateBefore: initDate.end,
        ordering: 'sample_delivery_date',
    })
    const api = useGroupApi('samples', searchForm)

    useEffect(() => {
        api.execute()
        setPageSize('landscape')
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    useEffectSkipFirst(() => {
        searchForm.update((f) => {
            f.disposedDateAfter = moment(`${periodForm.object.year}-${periodForm.object.month}-01`).startOf('month').format('YYYY-MM-DD')
            f.disposedDateBefore = moment(`${periodForm.object.year}-${periodForm.object.month}-01`).endOf('month').format('YYYY-MM-DD')
        })
    }, [periodForm.object])

    const chunks = () => {
        return _.chunk(api.response.groups, 9)
    }

    return (
        <>
            <div className="no-print">
                <Flex style={{ margin: 20 }}>
                    <div style={{ marginRight: 10, width: 250 }}>
                        <SelectField className="" form={periodForm} attr="year" selectItems={selectYears()} />
                    </div>
                    <div style={{ width: 150 }}>
                        <SelectField
                            className=""
                            form={periodForm}
                            attr="month"
                            selectItems={Array(12)
                                .fill(0)
                                .map((_, m) => ({ label: `${m + 1}月`, value: ('0' + (m + 1)).slice(-2) }))}
                        />
                    </div>

                    <div>
                        <Button
                            style={{ width: 200 }}
                            onClick={() => {
                                window.print()
                            }}
                        >
                            印刷プレビュー
                        </Button>
                    </div>
                </Flex>
            </div>
            {chunks().map((chunk, cidx) => {
                return (
                    <A4 landscape padding={0} key={'chunk-' + cidx}>
                        <div style={{ padding: 50, marginTop: 15 }}>
                            <LedgerHeader
                                headerTitle="検体保管・廃棄処理台帳"
                                recordTypeNum="RCL00026"
                                originalDocument="LSOP-RCL009"
                                versionNum="3"
                                timestamp={moment().format('YYYYMMDDHHmm')}
                            />
                            <div style={{ fontSize: 12, marginTop: 20 }}>
                                <table style={{ border: 'solid 2px black', width: '100%' }}>
                                    <thead>
                                        <Th style={{ width: 250, textAlign: 'left' }}>医療機関等名</Th>
                                        <Th style={{ width: 100 }}>検体ID</Th>
                                        <Th style={{ width: 110 }}>受付日</Th>
                                        <Th style={{ width: 110 }}>保管期限日</Th>
                                        <Th style={{ width: 110 }}>廃棄日</Th>
                                        <Th style={{ verticalAlign: 'middle', textAlign: 'left' }}>備考</Th>
                                    </thead>
                                    <tbody>
                                        {chunk.map((item, index) => {
                                            return (
                                                <tr key={'disposal-ledger' + index}>
                                                    <Td style={{ padding: '0 5px', verticalAlign: 'middle', textAlign: 'left' }}>{item.institutionName}</Td>
                                                    <Td style={{ padding: '0 5px', verticalAlign: 'middle' }}>{item.code}</Td>
                                                    <Td>{moment(item.deliveryDate).format('YYYY年MM月DD日')}</Td>
                                                    <Td>{moment(item.deliveryDate).add('M', 1).format('YYYY年MM月DD日')}</Td>
                                                    <Td>{moment(item.disposalHistoryDate).format('YYYY年MM月DD日')}</Td>

                                                    <Td style={{ padding: '0 5px', verticalAlign: 'middle', textAlign: 'left' }}>{item.disposalHistoryNote}</Td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                                    注釈：検体数は１、検体種類は尿、 保管条件は凍結とする。
                                </div>
                            </div>
                        </div>
                        <LedgerFooter page={cidx + 1}></LedgerFooter>
                    </A4>
                )
            })}
        </>
    )
}

export default withRouter(DisposalLedgerPage)
